/** 용신라이트 > 목차 */
export const CONTENTS = [
  { id: 1, title: '📖 용신이란 무엇일까요?' },
  { id: 2, title: '1. 내 사주에서 나를 돕는 기운!' },
  { id: 3, title: '2. 나를 도와주는 중심 기운과 보조 기운' },
  { id: 3, title: '3. 오행의 성향과 나에게 힘을 주는 오행' },
  { id: 4, title: '4. 나는 어떤 타입일까?' },
  { id: 5, title: '5. 지금 나에게 흐르는 기운' },
  { id: 5, title: '6. 생활 속 활용 아이디어' },
];

/** 용신라이트 > 목차 인덱스 → 페이지 매핑 */
export const CONTENTS_PAGE_MAP = {
  0: 1,
  1: 2,
  2: 3,
  3: 3,
  4: 4,
  5: 5,
  6: 5,
};
